import React, {Component} from 'react';

class IframeVideo extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="video-container black">
                    <iframe src="https://www.youtube.com/embed/Og2uZoHJRfA?autoplay=1&rel=0&controls=0&showinfo=0&modestbranding=true&" allowTransparency="true" frameBorder={0} scrolling="no" allowFullScreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen />
                </div>
            </div>
        )

    }

}

export default IframeVideo;


// WEBPACK FOOTER //
// ./src/components/iframe-video.js